import {
  ApiAuthUser,
  ApiOnboardingStep,
  ApiOnboardingType,
} from "@incendium/api";
import EcomPlatformOnboardingLayout from "features/onboarding/ecomPlatform/EcomPlatformOnboardingLayout";
import EcomPlatformOnboardingStep1 from "features/onboarding/ecomPlatform/EcomPlatformOnboardingStep1";
import EcomPlatformOnboardingStep2 from "features/onboarding/ecomPlatform/EcomPlatformOnboardingStep2";
import EcomPlatformOnboardingStep3 from "features/onboarding/ecomPlatform/EcomPlatformOnboardingStep3";
import EcomPlatformOnboardingStep4 from "features/onboarding/ecomPlatform/EcomPlatformOnboardingStep4";
import EcomPlatformOnboardingStep5 from "features/onboarding/ecomPlatform/EcomPlatformOnboardingStep5";
import EcomPlatformOnboardingStep6 from "features/onboarding/ecomPlatform/EcomPlatformOnboardingStep6";
import {
  getEcomPlatformConfig,
  normalizeEcomPlatformStep,
} from "features/onboarding/ecomPlatform/constants";
import { useEffect, useState } from "react";

interface IEcomPlatformOnboardingFlowProps {
  onboardingType: ApiOnboardingType;
  step: ApiOnboardingStep;
  onBack: () => void;
  onContinue: () => void;
  onContinueWithInvite?: () => void;
  continueLabel?: string;
  inactiveUsers?: ApiAuthUser[];
}

const ONBOARDING_STARTED = "AaXD8fI";

function EcomPlatformOnboardingFlow({
  onboardingType,
  step,
  onBack,
  onContinue,
  onContinueWithInvite,
  continueLabel,
  inactiveUsers,
}: IEcomPlatformOnboardingFlowProps) {
  const config = getEcomPlatformConfig(onboardingType);
  const [onboardingStartedRegistered, setOnboardingStartedRegistered] =
    useState(false);

  useEffect(() => {
    if (
      onboardingStartedRegistered ||
      !config ||
      config.onboardingType !== ApiOnboardingType.ONBOARDING_TYPE_WOO_COMMERCE
    ) {
      return;
    }
    (window as any).inc("append_lead_status", ONBOARDING_STARTED, true);
    setOnboardingStartedRegistered(true);
  }, [config, onboardingStartedRegistered]);

  if (!config) {
    return null;
  }

  const normalizedStep = normalizeEcomPlatformStep(config, step);

  const renderStepContent = () => {
    switch (normalizedStep) {
      case ApiOnboardingStep.BASIC_INFO:
        return <EcomPlatformOnboardingStep1 onConnected={onContinue} />;
      case ApiOnboardingStep.BUSINESS_INFO:
        return <EcomPlatformOnboardingStep2 onContinue={onContinue} />;
      case ApiOnboardingStep.PLATFORM:
        return (
          <EcomPlatformOnboardingStep3
            onContinue={onContinue}
            platformName={config.platformName}
          />
        );
      case ApiOnboardingStep.PIXEL:
        return <EcomPlatformOnboardingStep4 onContinue={onContinue} />;
      case ApiOnboardingStep.LOCATIONS:
        return <EcomPlatformOnboardingStep5 onContinue={onContinue} />;
      case ApiOnboardingStep.CONNECTIONS:
        return (
          <EcomPlatformOnboardingStep6
            onContinue={onContinue}
            onContinueWithInvite={onContinueWithInvite}
            continueLabel={continueLabel}
            inactiveUsers={inactiveUsers}
          />
        );
      default:
        return null;
    }
  };

  return (
    <EcomPlatformOnboardingLayout
      config={config}
      step={normalizedStep}
      onBack={onBack}
      showBack={normalizedStep !== config.firstStep}
    >
      {renderStepContent()}
    </EcomPlatformOnboardingLayout>
  );
}

export default EcomPlatformOnboardingFlow;
